export enum DashboardAgentStatusEnum {
  onDuty = 'OnDuty',
  onDutyOnBreak = 'OnDutyOnBreak',
  offDuty = 'OffDuty',
}
